// A Discussion or Assignment prompt failed. A Discussion inside a Parallel reports the Parallel as its widget.
howspace.widgets.onEvent('widget:prompt:failed', (widget, notification) => {
    howspace.aiGen.clearPromptTimeout(widget);
    real.button.reset(widget.find('.prompt-btn'), widget.find('.prompt-container'));
    real.notification.show(notification.object.error || howspace.translate('widget_prompt_failed'), 'danger');
});
